'use client';
import React, { Component, ErrorInfo, ReactElement } from 'react';
import ErroredComponent from '@spa/components/errored/errored.component';
import logger from '@spa/lib/logger';
import { unstable_rethrow } from 'next/navigation';

interface Props {
  readonly children: ReactElement;
  readonly editorMode: boolean;
  readonly type: string | null;
  readonly id: string | null;
}

interface State {
  hasError: boolean;
  error: string | null;
}

class ErrorBoundaryComponent extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    unstable_rethrow(error);
    logger.error({ err: error, errorInfo }, 'ErrorBoundary caught an error');
    this.setState({ hasError: true, error: error.toString() });
  }

  render(): ReactElement {
    const { error, hasError }: State = this.state;
    const { id, editorMode, type, children }: Props = this.props;

    return hasError ? (
      <ErroredComponent error={error} editorMode={editorMode} type={type} id={id} />
    ) : (
      children
    );
  }
}

export default ErrorBoundaryComponent;
